import { render } from "./PopUpKey.vue?vue&type=template&id=468a0b6c"
import script from "./PopUpKey.vue?vue&type=script&lang=js"
export * from "./PopUpKey.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__